import {createStore} from "vuex"
import HelperTools from '../utilities/helper'

import axios from 'axios'
const store = createStore({
    state(){
        return{
            foodMenu:[],
            imageArrayKey:0,
            panaromaHeight:0
        }
    },
    getters:{
        
    },
    mutations:{
        setFoodMenu(state,foodMenu){
            state.foodMenu = HelperTools.SanitizeMenuResponse(foodMenu)
        },
        setKey(state, key){
            state.imageArrayKey = key;
        },
        setPanaromaHeight(state, height){
            this.panaromaHeight = height
        }
    },
    actions:{
        getFoodMenu({commit}){
             axios.get('http://sushishogun.ca/wp-json/wp/v2/sushimenus?_embeded=1&_links=1').then(response => {
                console.log(response.data)
                commit('setFoodMenu',response.data)
            }).catch(error=>{
                console.log(error)
            })
        },
        
    },
    
})



export default store